import en from '@runtime/core/i18n/locales/en/profile.json'
import es from '@runtime/core/i18n/locales/es/profile.json'
import fr from '@runtime/core/i18n/locales/fr/profile.json'
import zh from '@runtime/core/i18n/locales/zh/profile.json'
import ja from '@runtime/core/i18n/locales/ja/profile.json'
import ko from '@runtime/core/i18n/locales/ko/profile.json'
import type { SupportedLocale } from '@runtime/core/i18n/localeConfig'

type StoreLocale = SupportedLocale

const GUEST_NICK_PATTERNS: Record<StoreLocale, string> = {
  fr: fr.guestNick,
  en: en.guestNick,
  es: es.guestNick,
  zh: zh.guestNick,
  ja: ja.guestNick,
  ko: ko.guestNick,
}

function resolveStoreLocale(locale?: unknown): StoreLocale {
  const candidate = String(locale || '')
    .trim()
    .toLowerCase()
  if (candidate in GUEST_NICK_PATTERNS) {
    return candidate as StoreLocale
  }

  const short = candidate.slice(0, 2)
  return short in GUEST_NICK_PATTERNS ? (short as StoreLocale) : 'en'
}

export function getGuestNick(index: number, locale?: unknown) {
  return GUEST_NICK_PATTERNS[resolveStoreLocale(locale)].replace(
    '{n}',
    String(index),
  )
}
